




































import { Component, Mixins } from 'vue-property-decorator'
import { TCWBadDataStructureError, TCWBaseError } from '@/plugins/TCWBaseError'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import * as ApiPath from '@/tcw/constant/ApiPath'
import BasePage from '@/tcw/components/BasePage'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import { EditableResponse, ToiawaseFileUpload } from '@/tcw/api/types'
import { AddFileInfo } from '@/components/help/types'
import ToiawaseInputForm from '@/components/help/organisms/ToiawaseInputForm.vue'

@Component({
  components: { TcwLayoutBasicTemplate, ToiawaseInputForm }
})
export default class ToiawasePage extends Mixins(BasePage, DataUpdateComponent) {
  get apiPath(): string {
    return ApiPath.Paths.Toiawase.post
  }

  private uploading = false

  private form = {
    title: '',
    shubetsu: '',
    naiyou: '',
    file: '',
    kinkyudo: 3,
    stack: ''
  }

  private fileList: ToiawaseFileUpload[] = []

  protected async confirmSubmit(): Promise<void> {
    const confirm = await this.$tcw.confirm({ type: 'warning', message: '送信して良いですか？' })
    if (confirm) {
      this.startSaveProc()
    }
  }

  protected async execSaveMain(): Promise<void> {
    // パスワード更新処理を実行
    await this.getWebApi().call(this.apiPath, 'POST', this.form)
  }

  private async uploadFiles(addFileInfo: AddFileInfo) {
    const apiPath = ApiPath.Paths.Toiawase.upload

    // 同時アップロード数制限
    if (addFileInfo.length > 5) {
      this.$tcw.message({
        type: 'error',
        message: '同時にアップロードできる上限に達しました'
      })
      return
    }

    try {
      this.uploading = true
      // 一つずつアップロード
      let insertIdx = addFileInfo.cursorIndex
      await Promise.all(
        addFileInfo.files.map(async f => {
          // リクエスト情報を生成してファイルアップロード
          const formData = new FormData()
          formData.append('uploadFile', f)
          const response: EditableResponse<ToiawaseFileUpload> = await this.getWebApi().postWithMultipart<
            EditableResponse<ToiawaseFileUpload>
          >(apiPath, formData)
          if (!response || !response.payload) {
            throw new TCWBadDataStructureError(
              'ファイルアップロードのレスポンスにデータがありません'
            )
          }

          const uploadInfo = response.payload

          // markdownにパスの記載を追加
          if (typeof response.payload.markdown === 'string') {
            this.form.naiyou = [
              this.form.naiyou.slice(0, insertIdx),
              uploadInfo.markdown,
              this.form.naiyou.slice(insertIdx, this.form.naiyou.length)
            ].join('')
            insertIdx += uploadInfo.markdown.length
          }

          // 添付ファイルリストに追加
          this.fileList.push(uploadInfo)
        })
      )
    } catch (e) {
      console.error(e)
      let message = ''
      if (e instanceof TCWBaseError) {
        message = e.outputMessage()
      } else {
        message = '不明なエラー'
      }
      this.$tcw.message({
        type: 'error',
        title: 'ファイルアップロードに失敗しました。',
        message
      })
    } finally {
      this.uploading = false
    }
  }
}
